import LobTypeTable from "./LobTypeTable";
import { permissionsSelector } from "../../../Login/selectors/permissionSelector";
import { useRecoilValue } from "recoil";
import { PERMISSIONS } from "../../../PermissionsConstants";

const LobType = () => {
  const viewPermission = PERMISSIONS.permission_utilities_lobtype_view;
  const userPermissions = useRecoilValue(permissionsSelector);
  return (
    <>{userPermissions.includes(viewPermission) ? <LobTypeTable /> : ""}</>
  );
};

export default LobType;
